module.exports = __webpack_public_path__ + "media/src/images/logos/calendly-02bfa63f4684eb60c723d78b4d279f06.png";